import { render, staticRenderFns } from "./Shop.container.vue?vue&type=template&id=54a81b83&"
import script from "./Shop.container.vue?vue&type=script&lang=ts&"
export * from "./Shop.container.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports